import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { ManageTagComponent } from './manage-tag/manage-tag.component';
import { ManageGlobalTagComponent } from './manage-global-tag/manage-global-tag.component';
import { ManageResearchStudiesComponent } from './manage-research-studies/manage-research-studies.component';

export const featuresRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    loadComponent: () =>
      import('./features.component').then((m) => m.FeaturesComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
        canActivate: [AuthGuard],
        data: { label: 'Dashboard' }
      },
      {
        path: 'manage-organizations',
        loadComponent: () =>
          import('./manage-organisation/manage-organisation.component').then(
            (m) => m.ManageOrganisationComponent
          ),
        data: { label: 'Organization' }
      },
      {
        path: 'manage-branches',
        loadComponent: () =>
          import('./manage-branches/manage-branches.component').then(
            (m) => m.ManageBranchesComponent
          ),
      },
      {
        path: 'manage-tag',
        loadComponent: () =>
          import('./manage-tag/manage-tag.component').then(
            (m) => ManageTagComponent
          )
      },
       {
        path: 'manage-global-tag',
        loadComponent: () =>
          import('./manage-global-tag/manage-global-tag.component').then(
            (m) => ManageGlobalTagComponent
          )
      },
       {
        path: 'manage-research-studies',
        loadComponent: () =>
          import('./manage-research-studies/manage-research-studies.component').then(
            (m) => ManageResearchStudiesComponent
          )
      },
      {
        path: 'manage-users',
        loadComponent: () =>
          import('./manage-user/manage-user.component').then(
            (m) => m.ManageUserComponent
          ),
      },
      {
        path: 'manage-message',
        loadComponent: () =>
          import('./manage-message/manage-message.component').then(
            (m) => m.ManageMessageComponent
          ),
      },
      {
        path: 'manage-branch-user-role-mapping',
        loadComponent: () =>
          import('./manage-branch-user-role-mapping/manage-branch-user-role-mapping.component').then(
            (m) => m.ManageBranchUserRoleMappingComponent
          ),
      },
      {
        path: 'manage-countries',
        loadComponent: () =>
          import('./manage-country/manage-country.component').then(
            (m) => m.ManageCountryComponent
          ),
      },
      {
        path: 'manage-states',
        loadComponent: () =>
          import('./manage-state/manage-state.component').then(
            (m) => m.ManageStateComponent
          ),
      },
      {
        path: 'manage-city',
        loadComponent: () =>
          import('./manage-city/manage-city.component').then(
            (m) => m.ManageCityComponent
          ),
      },
      {
        path: 'manage-localities',
        loadComponent: () =>
          import('./manage-locality/manage-locality.component').then(
            (m) => m.ManageLocalityComponent
          ),
      },
      {
        path: 'manage-districts',
        loadComponent: () =>
          import('./manage-district/manage-district.component').then(
            (m) => m.ManageDistrictComponent
          ),
      },
      {
        path: 'manage-applications',
        loadComponent: () =>
          import('./manage-application/manage-application.component').then(
            (m) => m.ManageApplicationComponent
          ),
      },
      {
        path: 'manage-modules',
        loadComponent: () =>
          import('./manage-module/manage-module.component').then(
            (m) => m.ManageModuleComponent
          ),
      },
      {
        path: 'manage-resources',
        loadComponent: () =>
          import('./manage-resource/manage-resource.component').then(
            (m) => m.ManageResourceComponent
          ),
      },
      {
        path: 'manage-scopes',
        loadComponent: () =>
          import('./manage-scope/manage-scope.component').then(
            (m) => m.ManageScopeComponent
          ),
      },
      {
        path: 'manage-permissions',
        loadComponent: () =>
          import('./manage-permission/manage-permission.component').then(
            (m) => m.ManagePermissionComponent
          ),
      },
      {
        path: 'manage-roles',
        loadComponent: () =>
          import('./manage-role/manage-role.component').then(
            (m) => m.ManageRoleComponent
          ),
      },
      {
        path: 'manage-access-matrix',
        loadComponent: () =>
          import('./manage-user-access-matrix/manage-user-access-matrix.component').then(
            (m) => m.ManageUserAccessMatrixComponent
          )
      },
      {
        path: 'user-module-mapping',
        loadComponent: () =>
          import('./user-module-mapping/user-module-mapping.component').then(
            (m) => m.UserModuleMappingComponent
          ),
      },
      {
        path: 'policy',
        loadComponent: () =>
          import('./policy/policy.component').then(
            (m) => m.PolicyComponent
          ),
      },
      
    ],
  },
];
